import { fetcher } from "helpers/fetcher";

import {
  TGetListCustomerSuccessReq,
  TGetListCustomerSuccessRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getListCustomerSuccess = async (
  payload: TGetListCustomerSuccessReq
) => {
  return await fetcher<
    TGetListCustomerSuccessRes,
    TGetListCustomerSuccessReq["data"]
  >(ENDPOINT.MANAGEMENT.GET_LIST_CUSTOMER_SUCCESS, {
    headers: {
      [API_HEADER.BU_ID]: payload.idBu,
    },
    data: payload.data,
  });
};

export const queryGetListCustomerSuccess = async (
  payload: TGetListCustomerSuccessReq
) => {
  return await getListCustomerSuccess(payload);
};

queryGetListCustomerSuccess._key = (payload?: TGetListCustomerSuccessReq) => [
  ENDPOINT.MANAGEMENT.GET_LIST_CUSTOMER_SUCCESS.url,
  payload,
];
